export var initialAddAuthState = {
    authorizedUserFirstName: { value: '', errorMessage: '', touched: false },
    authorizedUserLastName: { value: '', errorMessage: '', touched: false },
    authorizedUserBirthDate: { value: '', errorMessage: '', touched: false }
};
export var initialErrorDetails = {
    hasError: false,
    isBusinessError: false,
    businessErrorCode: '',
    businessErrorDescription: ''
};
